/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandVercel = createReactComponent("outline", "brand-vercel", "IconBrandVercel", [["path", { "d": "M3 19h18l-9 -15z", "key": "svg-0" }]]);

export { IconBrandVercel as default };
//# sourceMappingURL=IconBrandVercel.mjs.map
